<template>
  <div class="agreement-flow-with-agreement-request-id">
    <Loading v-if="!initialized" />
    <div class="agreement-flow-with-agreement-request-id--inner" v-if="initialized">
      <AgreementFlow
        :AgreementFlowServiceConstructorArgs="AgreementFlowServiceConstructorArgs"
        :shouldPreviewAsPrint="shouldPreviewAsPrint"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import {
  ModelPsAgreementRequests,
  ModelPsAgreementTemplate,
} from '../../models/fireModels/types'
import AgreementFlow from './AgreementFlow.vue'
import { initAgreementFlowServiceConstructorArgsWithAgreementTemplate } from './initAgreementFlowServiceWithAgreementRequest'

export default {
  name: 'AgreementFlowWithAgreementTemplateData',
  components: { AgreementFlow },
  props: {
    agreementTemplateData: {
      type: Object as PropType<ModelPsAgreementTemplate>,
      required: true,
    },
    agreementRequestData: {
      type: Object as PropType<Partial<ModelPsAgreementRequests>>,
      required: false,
    },
    shouldPreviewAsPrint: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      initialized: false,
    }
  },
  async mounted() {
    this.initialized = true
  },
  computed: {
    AgreementFlowServiceConstructorArgs() {
      return initAgreementFlowServiceConstructorArgsWithAgreementTemplate(
        this.agreementTemplateData,
        this.agreementRequestData,
      )
    },
  },
}
</script>
